import { TypeOf, yup } from '@guiker/yup-util'

export const backgroundCheckIdPathValidator = yup.object({
  targetUserId: yup.string().required(),
})

export type BackgroundCheckIdPathParam = TypeOf<typeof backgroundCheckIdPathValidator>
